import React from 'react';
import { HelpTooltip } from './HelpTooltip';

interface VolumeControlProps {
  volume: number;
  onVolumeChange: (volume: number) => void;
}

export const VolumeControl: React.FC<VolumeControlProps> = React.memo(({
  volume,
  onVolumeChange,
}) => {
  return (
    <div className="bg-medical-gray-50 rounded-lg p-4 border border-medical-gray-200">
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <label htmlFor="volume" className="text-medical-gray-700 font-semibold text-lg">
            Volume Level
          </label>
          <HelpTooltip 
            content="Set to a comfortable level. Headphones work best."
            position="right"
          />
        </div>
        <div className="flex items-center gap-4">
          <span className="text-medical-gray-500">🔇</span>
          
          <input
            id="volume"
            type="range"
            className="w-full"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={(e) => onVolumeChange(parseFloat(e.target.value))}
          />
          
          <span className="text-medical-gray-500">🔊</span>
          <span className="text-medical-blue-600 font-semibold font-mono text-sm w-12 text-right">
            {Math.round(volume * 100)}%
          </span>
        </div>
        <small className="text-medical-gray-500 text-sm">
          Best range: 30-50%
        </small>
      </div>
    </div>
  );
});